import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'
import { useEventContext } from 'context/EventContext'

import classes from './SocialLink.module.scss'

const SocialLink = ({ href, icon, name }) => {
  const eventContext = useEventContext({
    engagementComponent: 'footer',
  })

  return (
    <Link
      id={name}
      className={clsx('SocialLink', classes.iconLink)}
      {...eventContext.addEvent({
        engagementDestination: `go-to_social_${name}`,
        engagementDetails: `icon_social_${name}`,
        name: 'click',
      })}
      target="_blank"
      href={href}
    >
      <IconButton className={classes.iconButton}>
        <Icon icon={['fab', icon || name]} size={24} />
      </IconButton>
    </Link>
  )
}

export default SocialLink
